import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import ProjectCard from '../components/ProjectCard';
import './Work.css';

const FILTERS = ['ALL', 'Commercials', 'Short-form', 'Long-form'];

export default function Work() {
  const [projects, setProjects] = useState([]);
  const [filter, setFilter] = useState('ALL');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    supabase
      .from('projects')
      .select('*')
      .order('sort_order')
      .then(({ data }) => {
        setProjects(data || []);
        setLoading(false);
      });
  }, []);

  const filtered = filter === 'ALL'
    ? projects
    : projects.filter(p => p.tags?.includes(filter));

  return (
    <main className="work">
      <div className="work__header">
        <h1 className="work__heading">WORK</h1>
        <div className="work__filters">
          {FILTERS.map(f => (
            <button
              key={f}
              onClick={() => setFilter(f)}
              className={`work__filter ${filter === f ? 'work__filter--active' : ''}`}
            >
              {f}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <div className="work__grid">
          {[1,2,3,4,5,6].map(i => (
            <div key={i} className="work__skeleton">
              <div className="work__skeleton-thumb" />
              <div className="work__skeleton-text" />
            </div>
          ))}
        </div>
      ) : filtered.length === 0 ? (
        <div className="work__empty">
          <p>No projects yet in this category.</p>
        </div>
      ) : (
        <div className="work__grid">
          {filtered.map(p => (
            <ProjectCard key={p.id} project={p} />
          ))}
        </div>
      )}

      <div className="work__page-nav">
        <Link to="/" className="work__page-nav-item">← HOME</Link>
        <Link to="/about" className="work__page-nav-item">ABOUT →</Link>
      </div>
    </main>
  );
}
